import { jsx as _jsx } from "react/jsx-runtime";
import { Container, List, ListSubheader, Paper } from '@mui/material';
const SettingsContainer = ({ title, children }) => {
    return (_jsx(Container, Object.assign({ maxWidth: "sm", sx: { mt: 4 } }, { children: _jsx(Paper, Object.assign({ elevation: 2 }, { children: _jsx(List, Object.assign({ subheader: _jsx(ListSubheader, Object.assign({ component: "div", id: "settings-subheader" }, { children: title })) }, { children: children })) })) })));
};
export default SettingsContainer;
